// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Orny","importantInfo":"styles_importantInfo__17r1y"};